<template>
  <v-container fluid fill-height grid-list-lg>
    <v-layout
      justify-center
      align-center
    >
      <v-flex xs12 sm12 md10 lg5>
      <spinner v-if="dataLoading === true" line-fg-color="#28AFAF" size="large"></spinner>
        <v-card class="elevation-1" v-else>
        <v-toolbar color="primary">
          <v-toolbar-title class="white--text">Account Details</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn color="warning" class="white--text" @click.native="editAgency(agencyData)">Edit Password</v-btn>
          </v-toolbar>
        <v-card-media>
          <v-container fluid fill-height>
            <v-layout 
              justify-center
              align-center>
              <v-avatar
                  size="150px"
                  :tile="false"
                >
                <img :src="agencyData.logo_url || defaultLogo" alt="avatar">
              </v-avatar>
            </v-layout>
          </v-container>
        </v-card-media>
        <v-list>
          <v-list-tile>
              <v-list-tile-content>
                <v-list-tile-title class="text-xs-right">ID {{ agencyData.id }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
        </v-list>
          <v-card-title class="black--text">
              <div class="headline">{{ agencyData.company }}  </div>
            </v-card-title>
          <v-list two-line>
            <!-- <v-list-tile>
              <v-list-tile-action>
                <v-icon color="primary">fingerprint</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>{{ agencyData.id }}</v-list-tile-title>
                <v-list-tile-sub-title>ID</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-divider inset></v-divider> -->
          <v-list-tile>
            <v-list-tile-action>
              <v-icon color="primary">work</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ agencyType }}</v-list-tile-title>
              <v-list-tile-sub-title>Agency Type</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-divider inset></v-divider>
          <v-list-tile>
            <v-list-tile-action>
              <v-icon color="primary">account_box</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ agencyData.first_name }} {{ agencyData.last_name }}</v-list-tile-title>
              <v-list-tile-sub-title>Contact person</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-divider inset></v-divider>
          <v-list-tile>
            <v-list-tile-action>
              <v-icon color="primary">mail</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{agencyData.email}}</v-list-tile-title>
              <v-list-tile-sub-title>Email</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <span v-if="agencyData.city || agencyData.country || agencyData.zip_code">
            <v-divider inset></v-divider>
            <v-list-tile>
              <v-list-tile-action>
                <v-icon color="primary">location_on</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>{{agencyData.city}}</v-list-tile-title>
                <v-list-tile-title>{{agencyData.address}}</v-list-tile-title>
                <v-list-tile-sub-title>{{agencyData.country}} {{agencyData.zip_code}}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </span>
          <span v-if="agencyData.phone">
            <v-divider inset></v-divider>
            <v-list-tile>
              <v-list-tile-action>
                <v-icon color="primary">phone</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>{{agencyData.phone}}</v-list-tile-title>
                <v-list-tile-sub-title>Phone</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </span>
        <v-divider inset></v-divider>
          <v-list-tile>
            <v-list-tile-action>
              <v-icon color="primary">money</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>$ {{agencyData.balance}}</v-list-tile-title>
              <v-list-tile-sub-title>Current Balance</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        
          
        </v-list>
      </v-card>
    </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";
import Spinner from "vue-simple-spinner";
import defaultLogo from '../../../assets/placeholder_profile_photo-200x200.png'
export default {
  components: {
    Spinner
  },
  data() {
    return {
      search: "",
      dataLoading: true,
      agencyType: '',
      defaultLogo: defaultLogo,
      e1: 0,
      items: [],
      agencyData: []
    };
  },
  created() {
    axios.get("/me").then(response => {
      this.items = response.data;
      this.getData();
    });
  },
  methods: {
    editAgency(item) {
      this.$router.push({ path: `/agency/agencies/edit/password/${item.id}` });
    },
    getData() {
      axios.get("/users/" + this.items.id).then(response => {
        this.agencyData = response.data.user;
        this.agencyType = this.agencyData.is_provider === '1' ? "Provider" : "Agency"
        this.dataLoading = false;
      });
    }
  }
};
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/agency/Account/Account.vue